import '../App.css';
import React, { useState } from 'react';


const TopComment = ({text}) => {



  return (
    <div>
    	<div className="top-comment">
    		{text}
    		
    	</div>
    </div>
  );
}

export default TopComment;
